import {
    LeaseType,
    ProductType,
} from 'app/enums/label.enums'
import {
    CellConfig,
} from 'app/shared-components/SkyNetSpreadSheet/SkyNetSpreadSheet.types'
import {
    ForecastData as TForecastData,
} from 'app/requests/Forecast/Forecast.types'

export type ForecastData = TForecastData
export type ForecastDataFields = 'units' | 'actuals'

/* used only in Forecast Module */
export enum ForecastSpreadsheetDataTypeEnum {
    Forecast = 'Forecast',
    Actuals = 'Actuals',
}

export type ForecastDataSpreadsheetColumnsConfig = {
    name: string,
    title: string,
    disabled?: boolean,
    cellConfig?: CellConfig<any>
}[]

export type ForecastType = {
    id: number,
    isConfirmed: boolean,
    accountName: string,
    productType: ProductType,
    originAirportIataCode: string,
    destinationAirportIataCode: string,
    changedOn: string,
    changedBy: string,
    leaseType: LeaseType,
    forecasts: ForecastData[],
    actuallyShippedContainers: ForecastData[],
    responsibleUsers: string[],
    isOngoing?: boolean,
}

export type ForecastSpreadsheetDataType = ForecastType & {
    dataType?: ForecastSpreadsheetDataTypeEnum
} & Record<string, number>
